import { LikeDto } from '@plugins/faq-lib/types';

export const DEFAULT_FILTER_COLOR = '#5a6268';

export const DEFAULT_LIKE_DTO: LikeDto = { liked: 0, totalLikes: 0 };

export const TOAST_CLOSE_TIMEOUT = 5000;
